function escapeXml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function makePlaceholderSvg(title: string, subtitle?: string): string {
  const safeTitle = escapeXml(title.trim() || 'Image');
  const safeSubtitle = subtitle ? escapeXml(subtitle.trim()) : '';

  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="800" viewBox="0 0 1200 800" role="img" aria-label="${safeTitle}">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#F6F6F6"/>
      <stop offset="100%" stop-color="#E8E8E8"/>
    </linearGradient>
  </defs>
  <rect width="1200" height="800" fill="url(#g)"/>
  <g fill="none" stroke="#BDBDBD" stroke-width="10" opacity="0.6">
    <rect x="80" y="80" width="1040" height="640" rx="24"/>
    <path d="M200 600 L460 380 L650 520 L860 320 L1020 480"/>
    <circle cx="420" cy="300" r="42"/>
  </g>
  <g font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif" fill="#59585D">
    <text x="120" y="690" font-size="44" font-weight="700">${safeTitle}</text>
    ${safeSubtitle ? `<text x="120" y="740" font-size="28" opacity="0.85">${safeSubtitle}</text>` : ''}
  </g>
</svg>`;
}

export function makePlaceholderDataUrl(title: string, subtitle?: string): string {
  const svg = makePlaceholderSvg(title, subtitle);
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function applyImageFallback(img: HTMLImageElement, title: string, subtitle?: string): void {
  if (img.dataset.fallbackApplied === '1') return;
  img.dataset.fallbackApplied = '1';
  img.src = makePlaceholderDataUrl(title, subtitle ?? 'Photo unavailable');
}
